import React from "react";
import { Col, Form, Modal, Row } from "react-bootstrap";
import SbCancelBtn, { SBSaveUpdateBtn } from "../../Buttons/Buttons";
import Select from 'react-select';

const enablingOptions = [
    { value: "Enable", label: "Enable" },
    { value: "Disable", label: "Disable" }
]

const AddVariantMaster = (props) => {

    return (
        <>
            <Modal show={props.open} onHide={props.handleCloseModal} className='add-customer-modal add-role-modal' centered>
                <Modal.Header closeButton>
                    <Modal.Title>Add Variant Master</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row className='customer-form-fields'>
                        <Col>
                            <Row>
                                <Col md={4}>
                                    <div>
                                        <label>Variant Code <span className="required-asterisk">*</span></label>
                                        <Form.Control type="text" />
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div>
                                        <label>Variant Name <span className="required-asterisk">*</span></label>
                                        <Form.Control type="text" />
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div>
                                        <label>Parameter Name <span className="required-asterisk">*</span></label>
                                        <Form.Control type="text" />
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={4}>
                                    <div>
                                        <label>Parameter Type <span className="required-asterisk">*</span> </label>
                                        <Select
                                            className="react-select-container"
                                            classNamePrefix="react-select"
                                            // options={enablingOptions}
                                            placeholder="Select"
                                            menuPosition="fixed"
                                            menuShouldScrollIntoView={false}  // Prevents auto-scrolling issues
                                        />
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div>
                                        <label>Lookup Type <span className="required-asterisk">*</span> </label>
                                        <Select
                                            className="react-select-container"
                                            classNamePrefix="react-select"
                                            // options={enablingOptions}
                                            placeholder="Select"
                                            menuPosition="fixed"
                                            menuShouldScrollIntoView={false}  // Prevents auto-scrolling issues
                                        />
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div>
                                        <label>Is Mandatory <span className="required-asterisk">*</span> </label>
                                        <Select
                                            className="react-select-container"
                                            classNamePrefix="react-select"
                                            // options={enablingOptions}
                                            placeholder="Select"
                                            menuPosition="fixed"
                                            menuShouldScrollIntoView={false}  // Prevents auto-scrolling issues
                                        />
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <SbCancelBtn btnName="Cancel" onClickEffect={props.handleCloseModal} />
                    <SBSaveUpdateBtn btnName="Submit" onClickEffect={props.handleNextStep} />
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default AddVariantMaster;
